module.exports = __webpack_public_path__ + "static/media/03.96259231.png";